module.exports = __webpack_public_path__ + "img/facile.deeec462.svg";